import Create from "./Create";
import List from "./List";
import Update from "./Update";

export const ScheduleYourVisit = {
  List: List,
  Update: Update,
  Create: Create,
  Permissions: {
    create: "create:Form",
    read: "read:Form",
    list: "list:Form",
    delete: "delete:Form",
    update: "update:Form-slug-agende-sua-visita", //uniftec
  },
};
